import React from 'react';

// import styled components
import {
  PortfolioFinancingContainer,
  PortfolioFinancingContent,
  PortfolioFinancingWrapper,
} from './styled';

const PortfolioFinancing = () => (
  <PortfolioFinancingWrapper aria-label="Portfolio financing">
    <PortfolioFinancingContainer>
      <PortfolioFinancingContent>
        <h1>Portfolio Financing for Condos and Condotels</h1>
        <p>
          In comes what we call our portfolio option for condotel financing.
          This is a unique option because rather than selling the loan to Fannie
          Mae, we fund and service the loan, meaning you will receive your
          monthly mortgage statement from us, and make payments to us. When this
          occurs, we can offer innovative solutions because as the lender and
          servicer, we decide on a case-by-case basis when it makes sense to
          offer home loan financing for a condo or condotel.
        </p>
      </PortfolioFinancingContent>
    </PortfolioFinancingContainer>
  </PortfolioFinancingWrapper>
);

export default PortfolioFinancing;
